module.exports = __webpack_public_path__ + "static/media/icon-event-note.d56d9b7c.svg";